import React, { Component } from 'react';
import randomstring from 'uuid/v4';
import Node from './Node';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

// eslint-disable-next-line
import style from './_style.css';

class Tree extends Component {
    state = {
        node: {},
        collapsed: this.props.collapsed,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.node !== state.node) {
            state.node = props.node;
            return state;
        }
        return null;
    }

    handleClick = () => {
        console.log('handleClick');
        this.setState({ collapsed: !this.state.collapsed });
    };

    handleClickName = () => {
        console.log('handleClickName');
        if (!this.props.noExpandName)
            this.setState({ collapsed: !this.state.collapsed });
    };

    render() {
        const { node, collapsed } = this.state;
        const { renderNode } = this.props;
        return (
            <li className={node && node.children && node.children.length > 0 ? 'has-children' : ''}>
                <div className={"flex_full_row align_center inner " + (node && node.children && node.children.length > 0 ? 'inner-has-children' : 'inner-no-has-children')}>

                    {node && node.children && node.children.length > 0 && collapsed ? (
                        <div className="flex_auto_row collapse" onClick={this.handleClick}>  <ExpandLess /> </div>
                    ) : node && node.children && node.children.length > 0 ? (
                        <div className="flex_auto_row collapse" onClick={this.handleClick}>  <ExpandMore /> </div>
                    ) : (
                        <div className="margin_left_24" />
                    )}
                    <div className="flex_full_row" onClick={this.handleClickName}>
                        {renderNode(node)}
                    </div>
                </div>

                {node && node.children && node.children.length > 0 && !collapsed && (
                    <ul>
                        {node.children.map((c) => (
                            <Node {...this.props} key={randomstring()} node={c} renderNode={renderNode} />
                        ))}
                    </ul>
                )}
            </li>
        );
    }
}

export default Tree;



// WEBPACK FOOTER //
// ./src/components/tree/Node.js